import { render, staticRenderFns } from "./openTimeLevelRewardSetting.vue?vue&type=template&id=252454c4&scoped=true"
import script from "./openTimeLevelRewardSetting.vue?vue&type=script&lang=ts"
export * from "./openTimeLevelRewardSetting.vue?vue&type=script&lang=ts"
import style0 from "./openTimeLevelRewardSetting.vue?vue&type=style&index=0&id=252454c4&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "252454c4",
  null
  
)

export default component.exports